// AdminDashboard.tsx
import React, { useEffect } from 'react';
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from '../../firebaseConfig'; // Ensure you have auth exported from firebaseConfig
import { useNavigate, Routes, Route } from 'react-router-dom'; // Import useNavigate from React Router
import SideNav from './side-navigation/SideNav';
import Items from './sub-pages/item/Items';
import './AdminDashboard.less';
import Banner from './sub-pages/banner/Banner';

const AdminDashboard = () => { 
    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        const checkAuth = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/admin/sign-in'); // Redirect to sign-in if not authenticated
            }
        });

        // Clean up subscription on unmount
        return () => checkAuth();
    }, [navigate]);

    return (
        <div className="admin-dashboard">
            <SideNav />
            <div className="content">
                <Routes>
                    <Route path="items" element={<Items />} />
                    <Route path="banners" element={<Banner />} />
                </Routes>
            </div>
        </div>
    );
};

export default AdminDashboard;
